import { Trophy, Star, Users, TrendingUp } from "lucide-react";
import { IMAGES, DISCIPLINES } from "../data/content";
import { PageHero } from "../components/shared/PageHero";
import { Reveal } from "../components/shared/Reveal";
import { SectionHead } from "../components/shared/SectionHead";
import { PrimaryButton, GhostButton } from "../components/shared/Buttons";

const PILLARS = [
  { icon: Trophy, title: "A professional stage", text: "High-quality competition environments and international-standard event presentation — built around the athlete." },
  { icon: Users, title: "One community", text: "Compete alongside five martial arts communities in a single national festival of the arts." },
  { icon: Star, title: "Recognition", text: "Athlete recognition, official results and event honours that celebrate achievement in every discipline." },
  { icon: TrendingUp, title: "A future to climb", text: "Rankings and medal tables are planned as Kumite Games grows — your results will become part of its history." },
];

export default function Athletes() {
  return (
    <>
      <PageHero
        eyebrow="Athletes"
        title="Built for the Brave"
        intro="Kumite Games is being designed around the athlete experience — from the quality of the competition floor to the moment your result becomes part of the record."
        image={IMAGES.athlete}
        testId="athletes-page-hero"
      />
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <SectionHead
          eyebrow="The Athlete Experience"
          title="What to expect"
          testId="athlete-experience-heading"
        />
        <div className="grid gap-5 sm:grid-cols-2">
          {PILLARS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08} className="spotlight-card clip-notch border border-white/5 bg-ink-soft p-8 sm:p-10">
              <p.icon className="h-7 w-7 text-kred" />
              <h3 className="mt-6 font-head text-lg font-bold uppercase tracking-wide text-bone">{p.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-slate-400">{p.text}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-16">
          <h2 className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-slate-500">
            Founding disciplines
          </h2>
          <div className="mt-6 flex flex-wrap gap-3">
            {DISCIPLINES.map((d) => (
              <span key={d.slug} className="border border-white/10 px-5 py-3 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-slate-300">
                {d.name}
              </span>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-16 clip-notch border border-gold/20 bg-gold/[0.04] p-10 text-center sm:p-14">
          <h2 data-testid="athlete-registration-note" className="font-display text-4xl uppercase tracking-wide text-bone sm:text-5xl">
            Athlete Registration <span className="text-gold">Opens Soon</span>
          </h2>
          <p className="mx-auto mt-5 max-w-lg text-sm leading-relaxed text-slate-400 sm:text-base">
            Entry details, divisions and eligibility will be published with each discipline's
            participating organisation. Register your interest to be first to know.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <PrimaryButton to="/register" testId="athletes-register-button">
              Register Interest
            </PrimaryButton>
            <GhostButton to="/disciplines" testId="athletes-disciplines-button">
              Explore Martial Arts
            </GhostButton>
          </div>
        </Reveal>
      </section>
    </>
  );
}
